/* eslint-disable react/no-unescaped-entities */
import React from 'react';

const CookiePolicy = () => {
    return (
        <div className={'container mx-auto prose max-w-4xl mt-6 pb-12'}>
            <div data-custom-class="body">
                <div>
                    <strong>COOKIE POLICY</strong>
                </div>
                <div>
                    <strong>Last updated Oct 20, 2023</strong>
                </div>
                <div>
                    This Cookie Policy explains how HUDDA, humane digitalne rešitve, d.o.o. ("
                    <strong>Company</strong>," "<strong>we</strong>," "<strong>us</strong>," and "<strong>our</strong>")
                    uses cookies and similar technologies to recognize you when you visit our website at{' '}
                    <a href="https://kamzavikend.si" target="_blank" data-custom-class="link" rel="noreferrer">
                        https://kamzavikend.si
                    </a>{' '}
                    ("<strong>Website</strong>"). It explains what these technologies are and why we use them, as well
                    as your rights to control our use of them.
                </div>
                <div>
                    In some cases we may use cookies to collect personal information, or that becomes personal
                    information if we combine it with other information.
                </div>
                <div>
                    <strong>What are cookies?</strong>
                </div>
                <div>
                    Cookies are small data files that are placed on your computer or mobile device when you visit a
                    website. Cookies are widely used by website owners in order to make their websites work, or to work
                    more efficiently, as well as to provide reporting information.
                </div>
                <div>
                    Cookies set by the website owner (in this case, HUDDA, humane digitalne rešitve, d.o.o.) are called
                    "first-party cookies." Cookies set by parties other than the website owner are called "third-party
                    cookies." Third-party cookies enable third-party features or functionality to be provided on or
                    through the website (e.g., advertising, interactive content, and analytics). The parties that set
                    these third-party cookies can recognize your computer both when it visits the website in question
                    and also when it visits certain other websites.
                </div>
                <div>
                    <strong>Why do we use cookies?</strong>
                </div>
                <div>
                    We use first- and third-party cookies for several reasons. Some cookies are required for technical
                    reasons in order for our Website to operate, and we refer to these as "essential" or "strictly
                    necessary" cookies. Other cookies also enable us to track and target the interests of our users to
                    enhance the experience on our Online Properties. Third parties serve cookies through our Website for
                    advertising, analytics, and other purposes. This is described in more detail below.
                </div>
                <div>
                    <strong>How can I control cookies?</strong>
                </div>
                <div>
                    You have the right to decide whether to accept or reject cookies. You can exercise your cookie
                    rights by setting your preferences in the Cookie Consent Manager. The Cookie Consent Manager allows
                    you to select which categories of cookies you accept or reject. Essential cookies cannot be rejected
                    as they are strictly necessary to provide you with services.
                </div>
                <div>
                    The Cookie Consent Manager can be found in the notification banner and on our website. If you choose
                    to reject cookies, you may still use our website though your access to some functionality and areas
                    of our website may be restricted. You may also set or amend your web browser controls to accept or
                    refuse cookies.&nbsp;
                </div>
                <div>
                    The specific types of first- and third-party cookies served through our Website and the purposes
                    they perform are described in the table below (please note that the specific&nbsp;cookies served may
                    vary depending on the specific Online Properties you visit):
                    <strong>
                        <u>
                            <br />
                            <br />
                            Essential website cookies:
                        </u>
                    </strong>
                </div>
                <div>
                    <div>
                        These cookies are strictly necessary to provide you with services available through our Website
                        and to use some of its features, such as access to secure areas.
                    </div>
                    <section data-custom-class="body_text">
                        <section data-custom-class="body_text">
                            <div>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td>Name:</td>
                                            <td>kam_za_vikend_api_session</td>
                                        </tr>
                                        <tr>
                                            <td>Purpose:</td>
                                            <td>Track user sessions</td>
                                        </tr>
                                        <tr>
                                            <td>Provider:</td>
                                            <td>.kamzavikend.si</td>
                                        </tr>
                                        <tr>
                                            <td>Service:</td>
                                            <td>Digital Ocean Server</td>
                                        </tr>
                                        <tr>
                                            <td>Country:</td>
                                            <td>Germany</td>
                                        </tr>
                                        <tr>
                                            <td>Type:</td>
                                            <td>server_cookie</td>
                                        </tr>
                                        <tr>
                                            <td>Expires in:</td>
                                            <td>2 hours</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </section>
                        <div>
                            <table>
                                <tbody>
                                    <tr>
                                        <td>Name:</td>
                                        <td>JSESSIONID</td>
                                    </tr>
                                    <tr>
                                        <td>Purpose:</td>
                                        <td>
                                            Used to maintain an anonymous user session by the server in Java&trade; 2
                                            Platform Enterprise Edition web applications. It is a necessary cookie that
                                            expires at the end of a session.
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Provider:</td>
                                        <td>.nr-data.net</td>
                                    </tr>
                                    <tr>
                                        <td>Service:</td>
                                        <td>
                                            JavaServer Pages Technologies{' '}
                                            <a
                                                href="https://www.oracle.com/legal/privacy/privacy-policy.html"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                View Service Privacy Policy
                                            </a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Type:</td>
                                        <td>server_cookie</td>
                                    </tr>
                                    <tr>
                                        <td>Expires in:</td>
                                        <td>session</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </section>
                    <section data-custom-class="body_text">
                        <div>
                            <table>
                                <tbody>
                                    <tr>
                                        <td>Name:</td>
                                        <td>__cf_bm</td>
                                    </tr>
                                    <tr>
                                        <td>Purpose:</td>
                                        <td>
                                            Cloudflare places the cookie on end-user devices that access customer sites
                                            protected by Bot Management or Bot Fight Mode.
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Provider:</td>
                                        <td>.eu.auth0.com</td>
                                    </tr>
                                    <tr>
                                        <td>Service:</td>
                                        <td>
                                            Cloudflare{' '}
                                            <a
                                                href="https://jetpack.com/support/cookies/"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                View Service Privacy Policy
                                            </a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Country:</td>
                                        <td>United States</td>
                                    </tr>
                                    <tr>
                                        <td>Type:</td>
                                        <td>http_cookie</td>
                                    </tr>
                                    <tr>
                                        <td>Expires in:</td>
                                        <td>29 minutes</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </section>
                </div>
                <div>
                    <strong>
                        <u>
                            <br />
                            Performance and functionality cookies:
                        </u>
                    </strong>
                </div>
                <div>
                    <p>
                        These cookies are used to enhance the performance and functionality of our Website but are
                        non-essential to their use. However, without these cookies, certain functionality (like videos)
                        may become unavailable.
                    </p>
                    <div>
                        <section data-custom-class="body_text">
                            <div>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td>Name:</td>
                                            <td>XSRF-TOKEN</td>
                                        </tr>
                                        <tr>
                                            <td>Purpose:</td>
                                            <td>
                                                This cookie is written to help with site security in preventing
                                                Cross-Site Request Forgery attacks.
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Provider:</td>
                                            <td>.kamzavikend.si</td>
                                        </tr>
                                        <tr>
                                            <td>Service:</td>
                                            <td>
                                                Advertiser's website domain{' '}
                                                <a href="None" target="_blank">
                                                    View Service Privacy Policy
                                                </a>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Country:</td>
                                            <td>United States</td>
                                        </tr>
                                        <tr>
                                            <td>Type:</td>
                                            <td>server_cookie</td>
                                        </tr>
                                        <tr>
                                            <td>Expires in:</td>
                                            <td>2 hours</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </section>
                    </div>
                </div>
                <div>
                    <div>
                        <strong>
                            <u>
                                <br />
                                Analytics and customization cookies:
                            </u>
                        </strong>
                    </div>
                    <p>
                        These cookies collect information that is used either in aggregate form to help us understand
                        how our Website is being used or how effective our marketing campaigns are, or to help us
                        customize our Website for you.
                    </p>
                    <div>
                        <section data-custom-class="body_text">
                            <div>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td>Name:</td>
                                            <td>NRJS-0c6af8497c124248e3d</td>
                                        </tr>
                                        <tr>
                                            <td>Purpose:</td>
                                            <td>Tracking website performance</td>
                                        </tr>
                                        <tr>
                                            <td>Provider:</td>
                                            <td>bam.eu01.nr-data.net</td>
                                        </tr>
                                        <tr>
                                            <td>Service:</td>
                                            <td>New Relic</td>
                                        </tr>
                                        <tr>
                                            <td>Country:</td>
                                            <td>Germany</td>
                                        </tr>
                                        <tr>
                                            <td>Type:</td>
                                            <td>pixel_tracker</td>
                                        </tr>
                                        <tr>
                                            <td>Expires in:</td>
                                            <td>session</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </section>
                        <section data-custom-class="body_text">
                            <div>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td>Name:</td>
                                            <td>mp_#_mixpanel</td>
                                        </tr>
                                        <tr>
                                            <td>Purpose:</td>
                                            <td>
                                                This cookie is set by Mixpanel for analyzing traffic, and in particular
                                                how users reached the platform. Persistent cookie that expires after 1
                                                year
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Provider:</td>
                                            <td>.kamzavikend.si</td>
                                        </tr>
                                        <tr>
                                            <td>Service:</td>
                                            <td>
                                                MixPanel{' '}
                                                <a
                                                    href="https://mixpanel.com/legal/privacy-overview/"
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    View Service Privacy Policy
                                                </a>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Country:</td>
                                            <td>United States</td>
                                        </tr>
                                        <tr>
                                            <td>Type:</td>
                                            <td>http_cookie</td>
                                        </tr>
                                        <tr>
                                            <td>Expires in:</td>
                                            <td>11 months 30 days</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </section>
                    </div>
                </div>
                <div>
                    <strong>
                        <u>
                            <br />
                            Advertising cookies:
                        </u>
                    </strong>
                </div>
                <div>
                    <p>
                        These cookies are used to make advertising messages more relevant to you. They perform functions
                        like preventing the same ad from continuously reappearing, ensuring that ads are properly
                        displayed for advertisers, and in some cases selecting advertisements that are based on your
                        interests.
                    </p>
                    <div>
                        <section data-custom-class="body_text">
                            <div>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td>Name:</td>
                                            <td>did</td>
                                        </tr>
                                        <tr>
                                            <td>Purpose:</td>
                                            <td>
                                                Used to show site visitors targeted ads. It expires after 2 months or 1
                                                year.
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Provider:</td>
                                            <td>dev-kmeezh2kdaxj4vy4.eu.auth0.com</td>
                                        </tr>
                                        <tr>
                                            <td>Service:</td>
                                            <td>
                                                Pippio{' '}
                                                <a href="https://pippio.com/privacy/" target="_blank" rel="noreferrer">
                                                    View Service Privacy Policy
                                                </a>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Country:</td>
                                            <td>United States</td>
                                        </tr>
                                        <tr>
                                            <td>Type:</td>
                                            <td>http_cookie</td>
                                        </tr>
                                        <tr>
                                            <td>Expires in:</td>
                                            <td>1 year</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </section>
                    </div>
                </div>
                <div>
                    <strong>
                        <u>
                            <br />
                            Unclassified cookies:
                        </u>
                    </strong>
                </div>
                <div>
                    <p>
                        These are cookies that have not yet been categorized. We are in the process of classifying these
                        cookies with the help of their providers.
                    </p>
                    <div></div>
                </div>
                <div>
                    <strong>How can I control cookies on my browser?</strong>
                </div>
                <div>
                    As the means by which you can refuse cookies through your web browser controls vary from browser to
                    browser, you should visit your browser's help menu for more information. The following is
                    information about how to manage cookies on the most popular browsers:
                </div>
                <ul>
                    <li>
                        <a
                            href="https://support.google.com/chrome/answer/95647#zippy=%2Callow-or-block-cookies"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Chrome
                        </a>
                    </li>
                    <li>
                        <a
                            href="https://support.microsoft.com/en-us/windows/delete-and-manage-cookies-168dab11-0753-043d-7c16-ede5947fc64d"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Internet Explorer
                        </a>
                    </li>
                    <li>
                        <a
                            href="https://support.mozilla.org/en-US/kb/enhanced-tracking-protection-firefox-desktop?redirectslug=enable-and-disable-cookies-website-preferences&amp;redirectlocale=en-US"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Firefox
                        </a>
                    </li>
                    <li>
                        <a
                            href="https://support.apple.com/en-ie/guide/safari/sfri11471/mac"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Safari
                        </a>
                    </li>
                    <li>
                        <a
                            href="https://support.microsoft.com/en-us/windows/microsoft-edge-browsing-data-and-privacy-bb8174ba-9d73-dcf2-9b4a-c582b4e640dd"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Edge
                        </a>
                    </li>
                    <li>
                        <a
                            href="https://help.opera.com/en/latest/web-preferences/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Opera
                        </a>
                    </li>
                </ul>
                <div>
                    In addition, most advertising networks offer you a way to opt out of targeted advertising. If you
                    would like to find out more information, please visit:
                </div>
                <ul>
                    <li>
                        <a href="http://www.aboutads.info/choices/" target="_blank" rel="noopener noreferrer">
                            Digital Advertising Alliance
                        </a>
                    </li>
                    <li>
                        <a href="https://youradchoices.ca/" target="_blank" rel="noopener noreferrer">
                            Digital Advertising Alliance of Canada
                        </a>
                    </li>
                    <li>
                        <a href="http://www.youronlinechoices.com/" target="_blank" rel="noopener noreferrer">
                            European Interactive Digital Advertising Alliance
                        </a>
                    </li>
                </ul>
                <div>
                    <strong>What about other tracking technologies, like web beacons?</strong>
                </div>
                <div>
                    Cookies are not the only way&nbsp;to recognize or track visitors to a website. We may use other,
                    similar technologies from time to time, like web beacons (sometimes called "tracking pixels" or
                    "clear gifs"). These are tiny graphics files that contain a unique identifier that enables us to
                    recognize when someone has visited our Website or opened an email including them. This allows us,
                    for example, to monitor&nbsp;the traffic patterns of users from one page within a website to
                    another, to deliver or communicate with cookies, to understand whether you have come to the website
                    from an online advertisement displayed on a third-party website, to improve site performance, and to
                    measure the success of email marketing campaigns. In many instances, these technologies are reliant
                    on cookies to function properly, and so declining cookies will impair their functioning.
                </div>
                <div>
                    <strong>Do you use Flash cookies or Local Shared Objects?</strong>
                </div>
                <div>
                    Websites may also use so-called "Flash Cookies" (also known as Local Shared Objects or "LSOs") to,
                    among other things, collect and store information about your use of our services, fraud prevention,
                    and for other site operations.
                </div>
                <div>
                    If you do not want Flash Cookies stored on your computer, you can adjust the settings of your Flash
                    player to block Flash Cookies storage using the tools contained in the&nbsp;
                    <a
                        href="http://www.macromedia.com/support/documentation/en/flashplayer/help/settings_manager07.html"
                        target="_BLANK"
                        data-custom-class="link"
                        rel="noreferrer"
                    >
                        Website Storage Settings Panel
                    </a>
                    . You can also control Flash Cookies by going to the&nbsp;
                    <a
                        href="http://www.macromedia.com/support/documentation/en/flashplayer/help/settings_manager03.html"
                        target="_BLANK"
                        data-custom-class="link"
                        rel="noreferrer"
                    >
                        Global Storage Settings Panel
                    </a>
                    &nbsp;and&nbsp;following the instructions (which may include instructions that explain, for example,
                    how to delete existing Flash Cookies (referred to "information" on the Macromedia site), how to
                    prevent Flash LSOs from being placed on your computer without your being asked, and (for Flash
                    Player 8 and later) how to block Flash Cookies that are not being delivered by the operator of the
                    page you are on at the time).
                </div>
                <div>
                    Please note that setting the Flash Player to restrict or limit acceptance of Flash Cookies may
                    reduce or impede the functionality of some Flash applications, including, potentially, Flash
                    applications used in connection with our services or online content.
                </div>
                <div>
                    <strong>Do you serve targeted advertising?</strong>
                </div>
                <div>
                    Third parties may serve cookies on your computer or mobile device to serve advertising through our
                    Website. These companies may use information about your visits to this and other websites in order
                    to provide relevant advertisements about goods and services that you may be interested in. They may
                    also employ technology that is used to measure the effectiveness of advertisements. They can
                    accomplish this by using cookies or web beacons to collect information about your visits to this and
                    other sites in order to provide relevant advertisements about goods and services of potential
                    interest to you. The information collected through this process does not enable us or them to
                    identify your name, contact details, or other details that directly identify you unless you choose
                    to provide these.
                </div>
                <div>
                    <strong>How often will you update this Cookie Policy?</strong>
                </div>
                <div>
                    We may update&nbsp;this Cookie Policy from time to time in order to reflect, for example, changes to
                    the cookies we use or for other operational, legal, or regulatory reasons. Please therefore revisit
                    this Cookie Policy regularly to stay informed about our use of cookies and related technologies.
                </div>
                <div>The date at the top of this Cookie Policy indicates when it was last updated.</div>
                <div>
                    <strong>Where can I get further information?</strong>
                </div>
                <div>
                    If you have any questions about our use of cookies or other technologies, please email us at&nbsp;
                    <a href="mailto:info@kamzavikend.si">info@kamzavikend.si</a> or by post to:
                </div>
                <div>HUDDA, humane digitalne rešitve, d.o.o.</div>
                <div>Trg komandanta Staneta 8</div>
                <div>1000 Ljubljana</div>
                <div>Slovenia</div>
            </div>
        </div>
    );
};

export default CookiePolicy;
